import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackingEnabled } from "../utils/env";

export default function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        if (window.gtag && trackingEnabled) {
            window.gtag("config", process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID, {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);

    return null;
}